import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderStatusLogEntity } from '../../domain/entities/OrderStatusLogEntity'

export class OrderStatusLogModel extends OrderStatusLogEntity {
  constructor(dataDto: OrderStatusLogDto) {
    super()
    mapEntityProperties<OrderStatusLogEntity>(this, dataDto)
  }
}
